//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RbBanner from '@/elements/editorial/rb-banner/rb-banner.vue'

export default {
  name: 'rb-header-banner',
  components: {
    RbBanner,
  },
  props: {
    bannerSize: {
      type: Number,
      default: 1, // options: [1, 2, 3]
    },
  },
}
